var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import { styled, Tooltip, tooltipClasses } from '@mui/material';
import NaToolTip from './NatToolTip';
var HtmlTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { classes: { popper: className } })));
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: '#0A0926',
            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 2px 4px',
            borderRadius: '8px'
        },
        _b);
});
var InformationCard = function (_a) {
    var gridCol = _a.gridCol, cardData = _a.cardData, bgColor = _a.bgColor, imgWidth = _a.imgWidth, imgHeight = _a.imgHeight, titleClass = _a.titleClass, valueClass = _a.valueClass, courseData = _a.courseData;
    var showInformation = function (item) {
        return (((item === null || item === void 0 ? void 0 : item.title) && (item === null || item === void 0 ? void 0 : item.title) !== 'Backlogs Accepted') ||
            (item === null || item === void 0 ? void 0 : item.title) === 0 ||
            ((item === null || item === void 0 ? void 0 : item.title) === 'Backlogs Accepted' && !!(item === null || item === void 0 ? void 0 : item.value)));
    };
    return (React.createElement("div", { className: 'lfc-grid lfc-grid-cols-2 lfc-mb-4' }, cardData === null || cardData === void 0 ? void 0 : cardData.map(function (item, index) {
        return (React.createElement(Fragment, { key: index }, showInformation(item) ? (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-text-left lfc-text-xs  ".concat(bgColor ? 'lfc-bg-violet-1010 lfc-ml-2 lfc-rounded lfc-p-3' : '', " lfc-mt-4 lfc-justify-center") },
            React.createElement("div", { className: "lfc-flex" },
                React.createElement("img", { src: item === null || item === void 0 ? void 0 : item.image, height: imgHeight || 40, width: imgWidth || 40, alt: 'icon-image' }),
                React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-ml-3" },
                    React.createElement("span", { className: "lfc-text-gray-1250 lfc-text-[14px] ".concat(titleClass || '') }, item.title),
                    React.createElement("div", { className: "lfc-flex lfc-items-center" },
                        (item === null || item === void 0 ? void 0 : item.value) === 'N/A' ? (React.createElement(HtmlTooltip, { arrow: true, title: React.createElement(NaToolTip, { courseUrl: courseData === null || courseData === void 0 ? void 0 : courseData.courseUrl }), placement: "left" },
                            React.createElement("img", { src: '/assets/icons/course-finder/alert.svg', alt: 'alert-icon' }))) : (React.createElement(React.Fragment, null)),
                        React.createElement("div", { className: "lfc-font-medium lfc-text-gray-1001 ".concat(valueClass || 'lfc-text-lg', " ").concat(item.value === 'N/A' ? 'lfc-ml-2' : '', "\n                    }") }, item === null || item === void 0 ? void 0 : item.value)))))) : (React.createElement(React.Fragment, null))));
    })));
};
export default InformationCard;
//# sourceMappingURL=InformationCard.js.map